import React, { useState, useEffect, useCallback } from "react";
import Layout from "containers/LayoutV2";
import ThongKeApi from "service/ThongKe/ThongKeApi";
import { SearchBarDestop } from "./SearchBarDestop";
import { SummarySection } from "./SummarySection";
import { ChartSection } from "./ChartSection";
import { TableDanhSach } from "./ChiTiet/TableDanhSach";
import { pushNotification } from "utils/notifications";
import StoreApi from "service/phanQuyenApi";
import configsRole from "utils/configsRole";
import ConfigSystemApi from "service/QuanTriHeThong/CauHinhTinhLaiVaHeThong/ConfigSystemApi";
import { format } from "date-fns";
import UserApi from "service/userApi";

const buildApiParams = (filters) => {
  const year = filters.year;
  const month = filters.month;
  let dtFrom = filters.dtFrom ? format(filters.dtFrom, "dd/MM/yyyy") : null;
  let dtTo = filters.dtTo ? format(filters.dtTo, "dd/MM/yyyy") : null;
  if (!filters.dtFrom && !filters.dtTo) {
    if (month > 0 && year > 0) {
      dtFrom = format(new Date(year, month - 1, 1), "dd/MM/yyyy");
      dtTo = format(new Date(year, month, 0), "dd/MM/yyyy");
    } else if (year > 0) {
      dtFrom = format(new Date(year, 0, 1), "dd/MM/yyyy");
      dtTo = format(new Date(year, 11, 31), "dd/MM/yyyy");
    }
  }

  return {
    dtFrom: dtFrom,
    dtTo: dtTo,
    keywordHopDong: filters.keywordHopDong,
    keywordNgoaiLe: filters.keywordNgoaiLe,
    employee: filters.employee,
    CauHinhTaiSanId: filters.CauHinhTaiSanId
      ? parseInt(filters.CauHinhTaiSanId, 10)
      : 0,
    LoaiVay: filters.LoaiVay ? parseInt(filters.LoaiVay, 10) : 0,
  };
};

const initialFiltersState = {
  year: new Date().getFullYear(),
  month: 0,
  dtFrom: null,
  dtTo: null,
  keywordHopDong: "",
  keywordNgoaiLe: "",
  employee: "",
  CauHinhTaiSanId: 0,
  LoaiVay: 0,
};
const initialSummaryData = {
  TongChiGoc: 0,
  TongChiLaiHuyDongVon: 0,
  TongChiNgoaiLe: 0,
  TongChiKhac: 0,
  TongChiHoaHongTraGop: 0,
};
const initPhanQuyen = {
  chi: false,
  chi_inphieuchi: false,
  chi_chitiethopdong: false,
  chi_chitietkhachhang: false,
};

const initialChartData = Array.from({ length: 12 }, (_, i) => ({
  Thang: i + 1,
  TongChi: 0,
}));
const isEnabledConfig = (value) =>
  value === 1 || value === "1" || value === true;
const getConfigValue = (config, keys) => {
  if (!config) return undefined;
  for (const key of keys) {
    if (config[key] !== undefined) return config[key];
  }
  if (Array.isArray(config)) {
    const item = config.find((configItem) =>
      keys.some(
        (key) =>
          configItem.keyConfig?.toUpperCase() === key.toUpperCase() ||
          configItem.KeyConfig?.toUpperCase() === key.toUpperCase()
      )
    );
    return item?.valueConfig ?? item?.ValueConfig;
  }
  return undefined;
};

export const ThongKeChi = () => {
  const [filters, setFilters] = useState(initialFiltersState);
  const [phanQuyen, setPhanQuyen] = useState(initPhanQuyen);
  const [loading, setLoading] = useState(true);
  const [loadingData, setLoadingData] = useState({
    summary: true,
    chart: true,
    config: true,
  });
  const [summaryData, setSummaryData] = useState(initialSummaryData);
  const [chartData, setChartData] = useState(initialChartData);
  const [systemConfig, setSystemConfig] = useState(null);
  const [modalState, setModalState] = useState({
    show: false,
    type: "",
    title: "",
  });

  const LoadPhanQuyen = () => {
    setLoading(true);
    StoreApi.getAllQuyen()
      .then((response) => {
        if (response.status === 200) {
          const getRole = (code) =>
            response.data.some(
              (e) => e.ModuleCode?.toUpperCase() === code.toUpperCase()
            );
          setPhanQuyen({
            chi: getRole(configsRole.sRole.chi),
            chi_inphieuchi: getRole(configsRole.sRole.chi_inphieuchi),
            chi_chitiethopdong: getRole(
              configsRole.sRole.chi_chitiethopdong
            ),
            chi_chitietkhachhang: getRole(
              configsRole.sRole.chi_chitietkhachhang
            ),
          });
        }
        setLoading(false);
      })
      .catch(() => setLoading(false));
  };

  useEffect(() => {
    document.title = "Thống kê chi | Phần mềm quản lý cầm đồ Morman";
    LoadPhanQuyen();
  }, []);

  useEffect(() => {
    setLoadingData((prev) => ({ ...prev, config: true }));
    ConfigSystemApi.getCauHinhHeThong()
      .then((res) => {
        if (res.status === 200 && res.data) {
          setSystemConfig(res.data);
        }
      })
      .catch((err) => {
        console.error("Lỗi khi lấy cấu hình hệ thống:", err);
      })
      .finally(() => {
        setLoadingData((prev) => ({ ...prev, config: false }));
      });
  }, []);

  const fetchData = useCallback(() => {
    setLoadingData((prev) => ({ ...prev, summary: true, chart: true }));
    const summaryPromise = ThongKeApi.getSummaryChi(buildApiParams(filters));
    const chartPromise = ThongKeApi.getChartDataChi(buildApiParams(filters));
    Promise.all([summaryPromise, chartPromise])
      .then(([summaryRes, chartRes]) => {
        setSummaryData(summaryRes.data || initialSummaryData);

        if (chartRes.status === 200 && chartRes.data) {
          const fullChartData = initialChartData.map(
            (monthData) =>
              chartRes.data.find((d) => d.Thang === monthData.Thang) ||
              monthData
          );
          setChartData(fullChartData);
        } else {
          setChartData(initialChartData);
        }
      })
      .catch(() => {
        pushNotification("Tải dữ liệu thống kê thất bại!", "error");
        setSummaryData(initialSummaryData);
        setChartData(initialChartData);
      })
      .finally(() =>
        setLoadingData((prev) => ({ ...prev, summary: false, chart: false }))
      );
  }, [filters]);

  useEffect(() => {
    if (phanQuyen.chi) {
      fetchData();
    }
  }, [phanQuyen.chi, fetchData]);

  const handleApplyFilter = (newFilters) => {
    setFilters(newFilters);
  };

  const handleSummaryClick = (type, title) => {
    setModalState({ show: true, type, title });
  };

  // if (loading) return null;

  return (
    <Layout>
      {phanQuyen.chi === true ? (
        <>
          <div id="form-repeater" className="p-2">
            <div className="row header justify-content-start mb-1 ml-1">
              <img
                src="/app-assets/images/icon-thong-ke.png"
                alt="Mẫu hợp đồng"
              />
              <h1 className="text-info-home">Thống Kê Chi</h1>
            </div>

            <div className="card border-light mb-1 card-v2">
              <div className="card-body card-body-v2">
                {loadingData.config ? (
                  <div className="text-center p-5">Đang tải cấu hình...</div>
                ) : (
                  <SearchBarDestop
                    initialFilters={filters}
                    onApply={handleApplyFilter}
                    showPenalty={isEnabledConfig(systemConfig?.SuDungMaNhanVien)}
                    isCauHinhT77={isEnabledConfig(
                      getConfigValue(systemConfig, [
                        "isCauHinhT77",
                        "CauHinhNha777",
                      ])
                    )}
                  />
                )}
              </div>
            </div>

            <div className="card border-light mb-1 card-v2">
              <div className="card-body card-body-v2">
                {loadingData.config ? (
                  <div className="text-center p-5">Đang tải cấu hình...</div>
                ) : (
                  <SummarySection
                    data={summaryData}
                    loading={loadingData.summary}
                    onItemClick={handleSummaryClick}
                    showPenalty={isEnabledConfig(systemConfig?.HoaHongTraGop)}
                  />
                )}
              </div>
            </div>

            <div className="card border-light mb-1 card-v2">
              <div className="card-body card-body-v2">
                <ChartSection
                  data={chartData}
                  loading={loadingData.chart}
                  filters={buildApiParams(filters)}
                />
              </div>
            </div>
          </div>

          {modalState.show && (
            <TableDanhSach
              phanQuyen={phanQuyen}
              show={modalState.show}
              onHide={() => setModalState({ ...modalState, show: false })}
              type={modalState.type}
              title={modalState.title}
              filters={buildApiParams(filters)}
            />
          )}
        </>
      ) : (
        <div className="p-2">
          <div className="d-flex align-items-center mb-1 ml-1">
            <img
              src="/app-assets/images/icon-thong-ke.png"
              alt="Mẫu hợp đồng"
            />
            <h1 className="text-info-home mb-0 ms-2 fw-bold ml-1">
              Thống Kê Chi
            </h1>
          </div>
          <div className="card border-light mb-1 card-v2">
            <div className="card-body card-body-v2 text-center text-danger">
              Bạn không có quyền truy cập chức năng này.
            </div>
          </div>
        </div>
      )}
    </Layout>
  );
};
